import { Record as ImRecord, type RecordOf } from 'immutable';
import type { QcsSyncResourceStore } from '../core/resourceStoreTypes';

export const CATEGORIES_REDUCER_KEY = 'categoryStore';
export type CATEGORIES_REDUCER_KEY = typeof CATEGORIES_REDUCER_KEY;

export enum CategoryTypeEnum {
  INCOME = 'INCOME',
  EXPENSE = 'EXPENSE',
}

export type CategoryType = `${CategoryTypeEnum}`;

export enum UsageTypeEnum {
  BUSINESS = 'BUSINESS',
  PERSONAL = 'PERSONAL',
  RENTAL = 'RENTAL',
  FARMING = 'FARMING',
}

export type UsageType = `${UsageTypeEnum}`;

export type TaxGroupType = {
  BUSINESS?: string;
  FARMING?: string;
  RENTAL_PROPERTY?: string;
};

export type TaxFormType = {
  id?: string;
  country?: string;
  txfId?: string;
  name?: string;
  description?: string;
  displayOrder?: number;
  primary?: boolean;
};

export type BusinessTaxInfoType = {
  taxForm?: string;
  taxLineItem?: string;
  enabled?: boolean;
};

// NOTE:  These are extra properties, not part of the QCS schema, required to manage the UI form state
export type ExtraProps = {
  taxRelated?: boolean;
  taxForm?: string;
  taxGroups?: TaxGroupType;
  businessTaxInfo?: BusinessTaxInfoType;
};

export type CategoryProps = {
  id?: string;
  clientId?: string;
  parentClientId?: string | null;
  parentId?: string;

  type?: CategoryType;
  // NOTE: QCS returns a categoryType field that we re-map to a type field in transformers
  categoryType?: CategoryType;
  name?: string;
  description?: string;

  usageType?: string;

  isNotEditable?: boolean;
  isNotUserAssignable?: boolean;

  isExcludedFromBudgets?: boolean;
  isExcludedFromCategoryList?: boolean;
  isExcludedFromReports?: boolean;

  knownCategoryId?: string | null;
  isInvestment?: boolean;

  logoUrl?: string;
  txfId?: string;
  txfIds?: Record<string, string>;

  isDeleted?: boolean;
  modifiedAt?: string;
} & ExtraProps;

export type Category = RecordOf<CategoryProps>;

export const mkCategory = ImRecord<CategoryProps>({
  id: undefined,
  parentId: undefined,
  parentClientId: undefined,
  clientId: undefined,

  type: undefined,
  name: undefined,
  description: undefined,

  usageType: undefined,

  isNotEditable: undefined,
  isNotUserAssignable: undefined,

  isExcludedFromReports: undefined,
  isExcludedFromCategoryList: undefined,
  isExcludedFromBudgets: undefined,

  logoUrl: undefined,
  txfId: undefined,
  txfIds: undefined,
  knownCategoryId: undefined,

  isDeleted: undefined,
  modifiedAt: undefined,
});

// Known Cat Ids
export const PRIMARY_INCOME_CAT = '5750000000';

declare module 'app-components/utils/redux-store/rootState' {
  export default interface RootState {
    [CATEGORIES_REDUCER_KEY]: QcsSyncResourceStore<CategoryProps>;
  }
}

export type SubmitPayload = {
  category: CategoryProps;
};
